import axios from "axios";
import { GET, POST } from '_helpers/Fetch';
import { DENIED, VOL_HOME } from '_constants/PageRoutes';
import { ACCOUNT, SUBANNOUNCEMENTS, ORGANIZATION, GET_USER, GET_USER_CLAIM_URL } from '_constants/UserAPI';

export const userService = {
    KeepAlive,
    LogOff,
    GetClaims,
    GetUserInfo,
    UpdateUserInfo,
    // organization API calls below
    GetRegionAnnouncements,
    UpdateAccountInformation,
    GetOrganization,
    UpdateCompanyUrl,
}

async function KeepAlive() {
    try {
        await GET(ACCOUNT + '/KeepAlive');
    } catch (err) {
        return null;
    }
}

async function LogOff() {
    try {
        await GET(ACCOUNT + '/LogOff');
        window.location.href = VOL_HOME
    } catch (err) {
        return null;
    }
}

async function GetClaims() {
    try {
        const { data: UserObject } = await GET(GET_USER_CLAIM_URL);
        return UserObject;
    } catch (err) {
        console.log(err);
        return null;
    }
}

function GetUserInfo() {
    return axios.post(GET_USER + "GetUserInfo");
}

// update userInformation
function UpdateUserInfo(id, updatedUserDto) {
    return axios.post(GET_USER + "UpdateUserInfo?id=" + id, updatedUserDto);
}

/*
Organization API calls below
*/
async function GetOrganization(id) {
    try {
        const { data: Organization } = await GET(ORGANIZATION + "Get/" + id);
        return Organization;
    } catch (err) {
        return null;
    }
}

async function UpdateAccountInformation(id, updatedOrgDto) {
    try {
        const { data: Response } = await POST(ORGANIZATION + "UpdateAccountInformation" + "?id=" + id, updatedOrgDto);
        return Response;
    } catch (err) {
        return null;
    }
}

async function GetRegionAnnouncements(state, skipCount) {
    try {
        const { data: Announcements } = await GET(SUBANNOUNCEMENTS + "/state/" + state + "?skipCount=" + skipCount);
        return Announcements;
    } catch (err) {
        return null;
    }
}

function UpdateCompanyUrl(id, updatedOrgDto) {
    return axios.post(ORGANIZATION + "UpdateCompanyUrl?id=" + id, updatedOrgDto);
}
